import React from 'react';

const PageLoadingContext = React.createContext(() => () => {});

export default PageLoadingContext;
